module.exports = __webpack_public_path__ + "assets/img/roosterplatform-process-right.cec02567.png";